import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';
import { ERROR_CODES } from '../../config/const';

const state = {
  aiCoding: {
    isBusy: false,
    data: null,
    error: null,
    isTestBusy: false
  }
};

const mutations = {
  LOAD_AI_CODING_BUSY: (state, payload) => {
    state.aiCoding.isBusy = payload;
  },
  LOAD_AI_CODING_SUCCESS: (state, payload) => {
    state.aiCoding.data = payload;
    state.aiCoding.error = null;
  },
  LOAD_AI_CODING_FAIL: (state, payload) => {
    state.aiCoding.error = payload;
    state.aiCoding.data = null;
  },
  LOAD_AI_CODING_TEST_BUSY: (state, payload) => {
    state.aiCoding.isTestBusy = payload;
  },
};

const actions = {
  getPrompt: ({ commit, rootState }, { projectId }) => {
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    commit('LOAD_AI_CODING_BUSY', true);

    const url = `${API_HOST}/analysis/${projectId}/ai_coding`;
    return Axios.get(url, config)
      .then(r => {
        let data = r?.data?.data || r?.data;
        commit('LOAD_AI_CODING_SUCCESS', data);
        return data;
      })
      .catch((error) => {
        commit('LOAD_AI_CODING_FAIL', true);
        console.error(error);
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      })
      .finally(() => commit("LOAD_AI_CODING_BUSY", false));
  },

  createPrompt: ({ commit, rootState }, { projectId, data }) => {

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    commit('LOAD_AI_CODING_BUSY', true);

    const url = `${API_HOST}/analysis/${projectId}/ai_coding`;
    return Axios.post(url, data, config)
      .then(r => {
        let data = r?.data?.data || r?.data;
        commit('LOAD_AI_CODING_SUCCESS', data);
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('ai_coding.message.saved')
        });
        return data;
      })
      .catch((error) => {
        commit('LOAD_AI_CODING_FAIL', true);
        console.error(error);
        let errorMessage = 'messages.request.error';
        if(error?.response?.data?.message?.code == ERROR_CODES.UNIQUE_VIOLATION_CODE){
          errorMessage = 'ai_coding.message.duplicate';
        }
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t(errorMessage)
        });
      })
      .finally(() => commit("LOAD_AI_CODING_BUSY", false));
  },

  updatePrompt: ({ commit, rootState }, { projectId, data, promptId }) => {

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    commit('LOAD_AI_CODING_BUSY', true);

    const url = `${API_HOST}/analysis/${projectId}/ai_coding/${promptId}`;
    return Axios.put(url, data, config)
      .then(r => {
        let data = r?.data?.data || r?.data;
        commit('LOAD_AI_CODING_SUCCESS', data);
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('ai_coding.message.saved')
        });
        return data;
      })
      .catch((error) => {
        commit('LOAD_AI_CODING_FAIL', true);
        console.error(error);
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      })
      .finally(() => commit("LOAD_AI_CODING_BUSY", false));
  },

  deletePrompt: ({ commit, rootState }, { projectId, promptId }) => {

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    commit('LOAD_AI_CODING_BUSY', true);

    const url = `${API_HOST}/analysis/${projectId}/ai_coding/${promptId}`;
    return Axios.delete(url, config)
      .then(r => {
        let data = r?.data?.data || r?.data;
        commit('LOAD_AI_CODING_SUCCESS', data);
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('ai_coding.message.deleted')
        });
        return data;
      })
      .catch((error) => {
        commit('LOAD_AI_CODING_FAIL', true);
        console.error(error);
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      })
      .finally(() => commit("LOAD_AI_CODING_BUSY", false));
  },

  runTest: ({ commit, rootState }, { projectId, data }) => {

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    commit('LOAD_AI_CODING_TEST_BUSY', true);

    const url = `${API_HOST}/analysis/${projectId}/ai_coding/test`;
    return Axios.post(url, data, config)
      .then(r => {
        return r.data.data;
      })
      .catch((error) => {
        console.error(error);
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      }).finally(() => commit("LOAD_AI_CODING_TEST_BUSY", false));
  },

  updatePromptsOrder: ({ commit, rootState }, { projectId, order }) => {
    return Axios.put(`/analysis/${projectId}/ai_coding/update_order`, order).then(r => r.data.data);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};